<template>
    <el-form :model="ruleForm" :rules="rules"
             :class="[{ 'form-view': !isEdit }, 'form-switch', 'form-col', 'form-personal']"
             ref="ruleForm"
             label-width="100px">
        <div class="col-2 clearfix">
            <el-form-item label="姓名:" prop="name">
                <p class="f-view" v-text="ruleForm.name"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.name" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="性别:" prop="gender">
                <p class="f-view" v-text="genderText"></p>
                <el-radio-group class="f-edit" v-model="ruleForm.gender">
                    <el-radio v-for="(item, index) in selectMap.WB_GENDER" :key="item.value"
                              :label="item.value">
                        {{ item.text }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号:" prop="mobilePhone">
                <p class="f-view" v-text="ruleForm.mobilePhone"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.mobilePhone" :maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="邮箱:" prop="email">
                <p class="f-view" v-text="ruleForm.email"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.email" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="简历来源:" prop="resumeSource">
                <p class="f-view" v-text="getSelectMapText('WB_RESUME_SOURCE', ruleForm.resumeSource)"></p>
                <el-select class="f-edit" v-model="ruleForm.resumeSource"
                           placeholder="请选择简历来源">
                    <el-option
                            v-for="(item, index) in selectMap.WB_RESUME_SOURCE"
                            :label="item.text"
                            :key="index"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="招聘信息来源:">
                <p class="f-view" v-text="getSelectMapText('WB_SOURCE_FROM', ruleForm.sourceFrom)"></p>
                <el-select class="f-edit" v-model="ruleForm.sourceFrom"
                           placeholder="请选择招聘信息来源">
                    <el-option
                            v-for="(item, index) in selectMap.WB_SOURCE_FROM"
                            :label="item.text"
                            :key="index"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="当前所在地:" prop="residence">
                <p class="f-view" v-text="ruleForm.residence"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.residence" :maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="应聘城市:" prop="expectCityId">
                <p class="f-view" v-text="getSelectMapText('WB_POSITION_CITY', ruleForm.expectCityId)"></p>
                <el-select class="f-edit" v-model="ruleForm.expectCityId" placeholder="请选择应聘城市">
                    <el-option
                            v-for="(item, index) in selectMap.WB_POSITION_CITY"
                            :label="item.text"
                            :key="index"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="工作年限:" prop="workYears">
                <p class="f-view" v-text="getSelectMapText('WB_WORK_YEARS', ruleForm.workYears)"></p>
                <el-select class="f-edit" v-model="ruleForm.workYears" placeholder="请选择工作年限">
                    <el-option
                            v-for="(item, index) in selectMap.WB_WORK_YEARS"
                            :label="item.text"
                            :key="index"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出生日期:" prop="birthday">
                <p class="f-view" v-text="birthdayText"></p>
                <el-date-picker class="f-edit" :editable="false" type="date" placeholder="选择日期"
                                v-model="ruleForm.birthday"
                                style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="籍贯:" prop="origin">
                <p class="f-view" v-text="ruleForm.origin"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.origin" :maxlength="50" placeholder="户籍所在地，如：广东广州"></el-input>
            </el-form-item>
            <el-form-item label="证件类型:" prop="papersType">
                <p class="f-view" v-text="getSelectMapText('WB_ID_CARD_TYPE', ruleForm.papersType)"></p>
                <el-select class="f-edit" v-model="ruleForm.papersType" placeholder="请选择证件类型">
                    <el-option
                            v-for="(item, index) in selectMap.WB_ID_CARD_TYPE"
                            :label="item.text"
                            :key="index"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="证件号:" prop="papersNumber">
                <p class="f-view" v-text="ruleForm.papersNumber"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.papersNumber" placeholder="请输入证件号码"
                          :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="推荐人:" prop="recommender">
                <p class="f-view" v-text="recommenderText"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.recommender" placeholder="请输入内推码和姓名，如：GO0111张三"
                          :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="与推荐人关系:">
                <p class="f-view" v-text="ruleForm.relationship"></p>
                <el-input class="f-edit" v-model.trim="ruleForm.relationship" placeholder="请输入与推荐人的关系"
                          :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="期望薪资:" prop="expectSalary">
                <p class="f-view">{{ruleForm.expectSalary}}</p>
                <el-input class="f-edit" v-model.number="ruleForm.expectSalary" :min="0" placeholder="请输入期望薪资"
                          :maxlength="30" type="number"></el-input>
            </el-form-item>
            <el-form-item label="接受调剂:" prop="acceptRegulate">
                <p class="f-view" v-text="getSelectMapText('WB_ACCEPT_REGULATE', ruleForm.acceptRegulate)"></p>
                <el-radio-group class="f-edit" v-model="ruleForm.acceptRegulate">
                    <el-radio v-for="(item, index) in selectMap.WB_ACCEPT_REGULATE" :key="item.value"
                              :label="item.value">
                        {{ item.text }}
                    </el-radio>
                </el-radio-group>
            </el-form-item>
        </div>
        <div style="padding-right:30px">
            <el-form-item label="游戏经验:" prop="gameExperience">
                <p class="f-view pre-wrap" v-text="ruleForm.gameExperience" style="white-space: pre-line;"></p>
                <el-input class="f-edit" type="textarea" :maxlength="1000" :autosize="{ minRows: 3, maxRows: 5}"
                          v-model="ruleForm.gameExperience"
                          placeholder='请填写相关游戏经验'
                          resize="none"></el-input>
            </el-form-item>
            <el-form-item label="沟通记录:" prop="contactResult">
                <p class="f-view pre-wrap" v-text="ruleForm.contactResult" style="white-space: pre-line;"></p>
                <el-input class="f-edit" type="textarea" :maxlength="1000" :autosize="{ minRows: 3, maxRows: 5}"
                          v-model="ruleForm.contactResult"
                          placeholder='请填写候选人沟通记录'
                          resize="none"></el-input>
            </el-form-item>
            <el-form-item label="简历备注:" prop="remark">
                <p class="f-view pre-wrap" v-text="ruleForm.remark || '无'" style="white-space: pre-line;"></p>
                <el-input class="f-edit" type="textarea" :maxlength="1000" :autosize="{ minRows: 3, maxRows: 5}"
                          v-model="ruleForm.remark"
                          placeholder='请填写简历备注'
                          resize="none"></el-input>
            </el-form-item>
        </div>
    </el-form>
</template>
<script type="text/javascript">
    import { dateFormat } from 'modules/tools'
    import rules from 'modules/rules'
    import UserSearch from 'components/userSelect/searchDownList'
    import FormCommonMixin from 'mixins/formCommonMixin'
    import selectMapMixin from 'mixins/selectMapMixin'
    import fetchPositionListMixin from 'views/operation/fetchPositionListMixin'

    const formFields = {
        id: '',       // 简历id
        name: '',     // 姓名
        mobilePhone: '',  // 手机
        gender: '',       // 性别
        email: '',        // 邮箱
        remark: '',
        acceptRegulate: '',
        sourceFrom: '',
        resumeSource: '',   // 简历来源
        workYears: '',      // 工作年限
        birthday: '',       // 出生日期
        origin: '',         // 籍贯
        expectSalary: '',   // 期望薪资
        papersType: '',     // 证件类型
        papersNumber: '',   // 证件号码
        recommender: '',    // 内推人
        relationship: '',
        recommenderUser: null,
        residence: '',      // 当前工作地
        expectCityId: '',   // 期望工作地
        gameExperience: '', // 游戏经验
        contactResult: ''  // 沟通记录
    }

    export default {
        props: {
            init: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                urls: {
                    personUpdate: '/resume/update.api',
                    personUpdateCheck: '/resume/checkEdit.api'
                },
                ruleForm: formFields,
                resetData: {},
                rules: rules,
                isEdit: true
            }
        },
        mixins: [FormCommonMixin, selectMapMixin, fetchPositionListMixin],
        computed: {
            recommenderText () {
                return (this.ruleForm.recommenderUser && this.ruleForm.recommenderUser.name) || ''
            },
            postData () {
                let temp = Object.assign({}, this.ruleForm, {birthday: dateFormat(this.ruleForm.birthday)})
                delete temp.recommenderUser
                return temp
            },
            genderText () {
                let baseMap = {
                    1: '男',
                    2: '女'
                }
                return baseMap[this.ruleForm.gender]
            },
            birthdayText () {
                return dateFormat(this.ruleForm.birthday)
            }
        },
        watch: {
            init: 'extendRuleForm'
        },
        methods: {
            extendRuleForm () {
                Object.keys(formFields).forEach((item, index) => {
                    let val = typeof this.init[item] === 'number' ? (this.init[item] + '') : (this.init[item] || '')
                    this.ruleForm[item] = val
                    this.resetData[item] = val
                })
            },
            updateCheck () {
                axios.post(this.urls.personUpdateCheck, this.postData).then((res) => {
                    this.updateData()
                })
            },
            updateData () {
                axios.post(this.urls.personUpdate, this.postData, {'X-showMessage': true}).then((res) => {
                    Object.keys(formFields).forEach((item, index) => {
                        this.ruleForm[item] = res.result.bean[item]
                        this.resetData[item] = res.result.bean[item]
                    })
                    this.editData()
                })
            },
            editData () {
                this.isEdit = !this.isEdit
            },
            cancelEdit () {
                this.resetForm('ruleForm')
                this.resetDataFn()
                this.editData()
            },
            resetDataFn () {
                Object.keys(formFields).forEach((item, index) => {
                    this.ruleForm[item] = this.resetData[item]
                })
            },
            saveData (formName, callback) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        callback(this.postData)
                    } else {
                        console.log('not valid')
                        return false
                    }
                })
            }
        },
        created () {
            this.fetchPositionList()
        },
        components: {
            UserSearch
        }
    }

</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .form-personal {
        position : relative;
        .toggle-line {
            margin : 6px 0;
            .toggle-trigger {
                width : 100%;
                .el-icon-arrow-down {
                    transition : transform 0.2s ease;
                }
                .turn-around {
                    transform : rotate(180deg);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// personal.vue?7e82754a